module.exports = __webpack_public_path__ + "static/media/truck1.5f9f9932.jpg";